import { ArrowRight, Clock, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { formatRange } from "@/lib/currency";

const HERO_IMG =
  "https://images.unsplash.com/photo-1575909812796-4a0ae171a443?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwd29vZGVuJTIwZGVzayUyMGxhcHRvcCUyMHBsYW50fGVufDB8fHx8MTc4Mjg1NTAwM3ww&ixlib=rb-4.1.0&q=85";

export default function Hero({ currency, rates }) {
  const goTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden">
      {/* background image with strong overlay */}
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMG}
          alt=""
          aria-hidden
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-[#FAF9F6]/88" />
      </div>

      <div className="oak-container pt-20 pb-24 md:pt-32 md:pb-40">
        <div className="max-w-3xl">
          <h1
            data-testid="hero-title"
            className="oak-fade-up font-heading font-extrabold tracking-tight leading-[1.02] text-4xl md:text-6xl lg:text-7xl text-[#1A3622]"
          >
            A reliable website,
            <br />
            built properly, from{" "}
            <span className="whitespace-nowrap text-[#C17F59]">
              {formatRange(150, 500, currency, rates).split(" – ")[0]}
            </span>
            .
          </h1>

          <p
            data-testid="hero-subtitle"
            className="oak-fade-up oak-delay-2 mt-6 max-w-2xl text-lg md:text-xl leading-relaxed text-[#5C665F]"
          >
            Oakbridg is a quiet, dependable web studio for small businesses, freelancers, and
            independents. We build your site, then run it for you — hosting, updates and small
            tweaks all handled for a flat monthly fee. You focus on your business.
          </p>

          <div className="oak-fade-up oak-delay-3 mt-10 flex flex-wrap items-center gap-3">
            <button
              onClick={() => goTo("calculator")}
              data-testid="hero-cta-primary"
              className="inline-flex items-center gap-2 rounded-full bg-[#1A3622] px-7 h-12 text-base font-medium text-white transition-all hover:-translate-y-0.5 hover:shadow-lg hover:bg-[#122618]"
            >
              Get an instant price
              <ArrowRight className="w-4 h-4" />
            </button>
            <Link
              to="/projects"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 rounded-full bg-transparent text-[#1A3622] border border-[#1A3622] px-7 h-12 text-base font-medium transition-all hover:bg-[#F3EFE9]"
            >
              See recent work
            </Link>
          </div>

          <div className="oak-fade-up oak-delay-4 mt-12 flex flex-wrap items-center gap-x-8 gap-y-4 text-sm text-[#5C665F]">
            <span data-testid="hero-trust-1" className="inline-flex items-center gap-2">
              <Clock className="w-4 h-4 text-[#1A3622]" /> Live within 7 days
            </span>
            <span data-testid="hero-trust-2" className="inline-flex items-center gap-2">
              <ShieldCheck className="w-4 h-4 text-[#1A3622]" /> We host, update &amp; maintain it
            </span>
            <span data-testid="hero-trust-3" className="inline-flex items-center gap-2">
              <span className="inline-block w-2 h-2 rounded-full bg-[#C17F59]" />
              Fixed-price quote. No surprises.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
